import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=07713755&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=07713755&prod&scoped=true&lang=css"
import style1 from "./newsDetail.vue?vue&type=style&index=1&id=07713755&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07713755",
  null
  
)

export default component.exports